import { ErrorMessage, Field, FieldProps } from "formik";
import { InputTextarea, InputTextareaProps } from "primereact/inputtextarea";
import styled from "styled-components";
import { SPField } from "./sharedStyles";
import { concatClassnames } from "../../../utils/style/concatClassnames";
import React from "react";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";
import { useDebounce } from "../../../utils/hooks/useDebounce";

interface SPFormikTextAreaProps extends InputTextareaProps {
  label?: string;
  name: string;
  required?: boolean;
  hideErrorMessage?: boolean;
}

export const SPFormikTextArea = (props: SPFormikTextAreaProps) => {
  const {
    label,
    disabled,
    value,
    name,
    required,
    hideErrorMessage = false,
    maxLength,
    ...rest
  } = props;

  const L = useLocStore(LocContext.GENERAL);

  return (
    <SPField
      className={concatClassnames([
        "sp-formik-text-area-container",
        disabled && "spfield--disabled",
      ])}
    >
      {!!label && (
        <label
          className="sp-formik-label"
          htmlFor={name}
          onClick={() => {
            console.log(props);
          }}
        >
          {label}
          {!!required && <span className="required">*</span>}
        </label>
      )}
      <Field name={name}>
        {(props: FieldProps<SPFormikTextAreaProps["value"]>) => {
          const { field, form, meta } = props;

          const debouncedText = useDebounce(field.value, 300);
          const count = debouncedText?.length ?? 0;

          return (
            <div className="input-error-container">
              <StyledSPTextArea
                id={name}
                disabled={disabled}
                {...field}
                {...rest}
                value={field.value ?? ""}
                maxLength={maxLength}
              />

              {!!maxLength && (
                <div style={{ marginLeft: "auto" }}>
                  {L.id("9553158a30b7").split("{0} tegn igjen", [
                    maxLength - count,
                  ])}
                </div>
              )}

              {!hideErrorMessage && (
                <ErrorMessage
                  className="input-error-container__error-msg"
                  component="div"
                  name={name}
                />
              )}
            </div>
          );
        }}
      </Field>
    </SPField>
  );
};

const StyledSPTextArea = styled(InputTextarea)`
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: 100px;
`;
